import { CopySVG } from 'common/assets';
import DeleteButton from 'components/common/delete-icon-button';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import { Button } from 'components/elements/buttons';
import { TextLabelPlacementEnum } from 'components/elements/custom-form-control';
import { useFormState } from 'components/elements/form';
import Text from 'components/elements/text';
import { CardSection, SeparatorHorizontal } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import ScheduleAddOnsTable from './add-ons-table';
import ScheduleAirlineTable from './airlines-table';
import ScheduleGuestTable from './guest-table';
import { ScheduleCardHeader, ScheduleCardHeaderLeft } from '../../style';
import { TicketSaleFormType } from '../form-type';

interface Props {
  parentIndex: number;
  onRemove: () => void;
  fieldLength?: number;
  isParentError: boolean;
}

const name = `flightSales` as const;

export default function ScheduleCard(props: Props) {
  const { t } = useTranslation();
  const { getValues, setValue } = useFormContext<TicketSaleFormType>();

  const onDuplicate = React.useCallback(() => {
    const ticketSales = getValues(name);
    const ticketSale = ticketSales[props.parentIndex];
    setValue(name, [...ticketSales, ticketSale]);
  }, [getValues, props.parentIndex, setValue]);

  const { editable } = useFormState();

  return (
    <CardSection>
      <ScheduleCardHeader>
        <ScheduleCardHeaderLeft>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: 16,
              alignItems: 'center',
            }}
          >
            <Text variant="HeadingXSmall">
              {t('ticketSales:schedule_extra', {
                extra: props.parentIndex + 1,
              })}
            </Text>
            {editable && (
              <Button
                variant="default"
                startEnhancer={(color, size) => (
                  <CopySVG color={color} size={size} />
                )}
                buttonType="tertiary"
                onClick={onDuplicate}
              >
                {t('common:duplicate_schedule')}
              </Button>
            )}
          </div>
          <Input
            type="text"
            name={`flightSales.${props.parentIndex}.bookingCode`}
            label={t('common:booking_code')}
            labelPlacement={TextLabelPlacementEnum.Left}
            placeholder={t('common:booking_code')}
            noMargin
          />
        </ScheduleCardHeaderLeft>
        {(props.fieldLength || 0) > 1 && editable && (
          <>
            <SeparatorHorizontal $margin={16} />
            <DeleteButton
              onClick={props.onRemove}
              rootStyle={{ height: '32px' }}
            />
          </>
        )}
      </ScheduleCardHeader>
      <Separator gap={24} />
      <ScheduleGuestTable parentIndex={props.parentIndex} />
      <Separator gap={24} />
      <ScheduleAirlineTable parentIndex={props.parentIndex} />
      <Separator gap={24} />
      <ScheduleAddOnsTable parentIndex={props.parentIndex} />
    </CardSection>
  );
}
